// applies to north american phone number
export const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

export const phoneFormatRegex = (phoneNumber: string) => {
    return phoneNumber.replace(phoneRegex, '($1) $2-$3');
};
